import { FormTextInputComponent } from 'src/features/generalForms/builder/types/TextInput';
import { FormTextInput, FormTextInputSettings } from './formTextInput';


export const FormMultipleTextInput: FormTextInputComponent = (props) => <FormTextInput type={'text-area'} {...props} />;

FormMultipleTextInput.craft = {
  displayName: 'Multiple line',
  rules: { canDrag: () => true },
  related: { settings: FormTextInputSettings },
};
